import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  checkAdsBlocked,
  checkBar,
  getAudioContext,
  getAudioFormats,
  getBatteryStatus,
  getBuildID,
  getConnection,
  getDeviceMemory,
  getHardwareConcurrency,
  getMediaDevices,
  getPermissionsStatus,
  getVideoFormats,
  getWebGL,
} from "../utils/helpers";
import {
  isIndexedDBAvailable,
  isLocalStorageAvailable,
  isSessionStorageAvailable,
} from "../utils/helpers/isStorageAvailable";

export const useGetDataForJSAttributes = () => {
  const [attributesJS, setAttributesJS] = useState(null);
  const {
    t,
    i18n: { language },
  } = useTranslation();

  useEffect(() => {
    const fetchData = async () => {
      // bars
      const locationBar = checkBar("locationBar");
      const menuBar = checkBar("menuBar");
      const personalBar = checkBar("personalBar");
      const statusBar = checkBar("statusBar");
      const toolBar = checkBar("toolBar");

      // mediaDevices array
      const mediaDevices = await getMediaDevices(t);
      // the build identifier of the browser
      const buildID = getBuildID(t);
      // check AdsBlock
      const adblock = await checkAdsBlocked();

      // audioFormats array
      const { audioFormats } = getAudioFormats(t);

      // videoFormats array
      const { videoFormats } = getVideoFormats(t);

      // sensors
      const accelerometer = "Accelerometer" in window;
      const gyroscope = "Gyroscope" in window;
      const proximitySensor = "ProximitySensor" in window;

      // connection
      const connection = getConnection(t);

      // status of battery
      const battery = await getBatteryStatus(t);

      // audioContext and frequencyAnalyser arrays
      const { audioContext, analyser } = getAudioContext();

      // storage, db
      const localStorageSupported = isLocalStorageAvailable();
      const sessionStorageSupported = isSessionStorageAvailable();
      const indexedDBSupported = isIndexedDBAvailable();

      // WebGL
      const { webGLVendor, webGLRenderer, webGLParameters } = getWebGL(t);

      // permissions
      const permissions = await getPermissionsStatus(t);

      // hardwareConcurrency
      const hardware = getHardwareConcurrency(t);

      // deviceMemory
      const deviceMemory = getDeviceMemory(t);

      const updatedAttributes = {
        // bars
        locationBar,
        menuBar,
        personalBar,
        statusBar,
        toolBar,
        // mediaDevices array
        mediaDevices,
        // the build identifier of the browser
        buildID,
        // check AdsBlock
        adblock,
        // audioFormats array
        audioFormats,
        // videoFormats array
        videoFormats,
        // sensors
        accelerometer,
        gyroscope,
        proximitySensor,
        // connection array
        connection,
        // status of battery
        battery,
        // audioContext and frequencyAnalyser arrays
        audioContext,
        analyser,
        // storage, db
        localStorageSupported,
        sessionStorageSupported,
        indexedDBSupported,
        // permissions array
        permissions,
        // screen sizes
        availableTop: window.screen.availTop,
        availableLeft: window.screen.availLeft,
        availableHeight: window.screen.availHeight,
        availableWidth: window.screen.availWidth,
        // WebGL
        webGLVendor,
        webGLRenderer,
        webGLParameters,
        hardware,
        deviceMemory,
      };

      setAttributesJS(prevState => ({
        ...prevState,
        ...updatedAttributes,
      }));
    };

    fetchData();
  }, [language]);
  return { attributesJS };
};
